import { ModalCreateDataTable } from "pages/gdt/modals/ModalCreateDataTable";
import { useProjectTablesTableContext } from "./provider/ProjectTablesTableProvider";
import { EuiModal } from "@inscopix/ideas-eui";
import { css } from "@emotion/react";
import { isNonNull } from "utils/isNonNull";
import { ModalCreateAnalysisTable } from "pages/gdt/modals/ModalCreateColumn/ModalCreateAnalysisTable";
import { ModalDeleteTable } from "pages/gdt/modals/ModalDeleteTable";
import { ModalEditFolder } from "pages/gdt/modals/ModalEditFolder";
import { ModalDeleteFolder } from "pages/gdt/modals/ModalDeleteFolder";
import { ModalDeleteTables } from "pages/gdt/modals/ModalDeleteTables";
import { ModalCreateFolder } from "pages/gdt/modals/ModalCreateFolder";
import { ModalEditTable } from "pages/gdt/modals/ModalEditTable";

export const ProjectTablesModals = () => {
  const editingTable = useProjectTablesTableContext((s) => s.editingTable);
  const editingFolder = useProjectTablesTableContext((s) => s.editingFolder);
  const visibleModal = useProjectTablesTableContext((s) => s.visibleModal);
  const onCloseModal = useProjectTablesTableContext((s) => s.onCloseModal);

  switch (visibleModal) {
    case "createData":
      return (
        <ModalCreateDataTable folder={editingFolder} onClose={onCloseModal} />
      );
    case "createAnalysis":
      return (
        <EuiModal
          onClose={onCloseModal}
          css={css`
            width: 900px;
            max-width: 900px;
          `}
        >
          <ModalCreateAnalysisTable
            folderId={editingFolder?.id}
            onClose={onCloseModal}
          />
        </EuiModal>
      );

    case "editAnalysis":
      return isNonNull(editingTable) ? (
        <ModalEditTable table={editingTable} onClose={onCloseModal} />
      ) : null;
    case "editData":
      return isNonNull(editingTable) ? (
        <ModalEditTable table={editingTable} onClose={onCloseModal} />
      ) : null;
    case "deleteTable":
      return isNonNull(editingTable) ? (
        <ModalDeleteTable table={editingTable} onClose={onCloseModal} />
      ) : null;
    case "editFolder":
      return isNonNull(editingFolder) ? (
        <ModalEditFolder folder={editingFolder} onClose={onCloseModal} />
      ) : null;

    case "deleteFolder":
      return isNonNull(editingFolder) ? (
        <ModalDeleteFolder folder={editingFolder} onClose={onCloseModal} />
      ) : null;
    case "deleteTables":
      return <ModalDeleteTables onClose={onCloseModal} />;
    case "createFolder":
      return <ModalCreateFolder onClose={onCloseModal} />;
    case null:
      return null;
  }
};
